var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.8777C5.86667 16.8777 2.5 13.511 2.5 9.37769H3.27778C3.27778 13.0888 6.28889 16.0999 10 16.0999C13.7111 16.0999 16.7222 13.0888 16.7222 9.37769H17.5C17.5 13.511 14.1333 16.8777 10 16.8777Z",
    fill: "#24293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80005 10.0888H8.6556C8.70005 10.811 9.23338 11.311 10.0223 11.311C10.7667 11.311 11.3223 10.8554 11.3223 10.111C11.3223 8.4221 7.91116 9.16655 7.91116 6.78877C7.91116 5.79988 8.72227 4.98877 9.94449 4.98877C11.1667 4.98877 11.8889 5.81099 11.9445 6.81099H11.0889C11.0445 6.18877 10.6112 5.69988 9.88894 5.69988C9.2556 5.69988 8.77783 6.15544 8.77783 6.75544C8.77783 8.44432 12.2 7.69988 12.2 10.0777C12.2 11.211 11.3112 12.0332 10 12.0332C8.68894 12.0332 7.83338 11.1999 7.80005 10.0888Z",
    fill: "#24293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.389 4.32227H9.61121V5.41115H10.389V4.32227Z",
    fill: "#24293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.389 11.7444H9.61121V12.6777H10.389V11.7444Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.2f1320b3b9ba191015d087d98e33a54a.svg";
export { ForwardRef as ReactComponent };